<template>
  <v-parallax src="../../assets/mikebanner.jpeg"
      >
  <v-row>
    <v-col class="col-12 my-auto text-center">
      <h2 class="bannerheadingh2">Welcome to </h2>
      <h1 class="bannerheadingh1">Fantasy Boxing</h1>
    </v-col>
  </v-row>
  <!-- <v-row class="secondary">
    <v-col class="col-8 my-auto mx-auto text-center">
        <v-row class="black--text">
          <v-col class="col-6 text-right">
            hello
          </v-col>
          <v-col class="col-6 text-left">
            bye
          </v-col>
        </v-row>
    </v-col>
  </v-row> -->
  </v-parallax>
</template>

<script>
export default {
  data: () => ({
  }),
}
</script>

<style lang="sass">
.bannerheadingh1
  font-size: 70px
  text-transform: uppercase

.bannerheadingh2 
  font-size: 55px
  text-transform: uppercase
  font-weight: bold
</style>